module.exports = __webpack_public_path__ + "img/package-plus.f601c245.svg";